/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdList = {
    type: 'array',
    contains: {
        type: 'Ad',
    },
} as const;
